<template>
  <div class="project-selector">
    <input v-model="selectProjects.length" type="hidden" name="projects" />
    <div class="row mb-2 mt-2 align-items-end">
      <div class="col-6">
        <label>โครงการที่รองรับ</label>
        <div class="search-input-wrapper">
          <input
            v-model="searchProject"
            type="text"
            class="form-control search-input"
            :placeholder="$t('feature.article.setting.project_search')"
          />
          <span class="search-icon">
            <i class="fas fa-search"></i>
          </span>
        </div>
      </div>

      <div class="filter col">
        <label>จังหวัด</label>
        <el-select
          v-model="filterProvince"
          class="input"
          placeholder="จังหวัด"
          clearable
          multiple
          value-key="key"
          @change="filterProjectByProvince"
        >
          <el-option
            v-for="type in province"
            :key="type.key"
            :label="type.name"
            :value="type"
          >
          </el-option>
        </el-select>
      </div>

      <div class="filter col">
        <label>ประเภท</label>
        <el-select
          v-model="filterProjectType"
          class="input"
          placeholder="ประเภทโครงการ"
          clearable
          value-key="key"
          @change="filterProjectByProjectType"
        >
          <el-option
            v-for="type in projectTypes"
            :key="type.key"
            :label="type.name"
            :value="type"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div
      v-if="projects && selectProjects"
      :class="{ notActive: !!disabled }"
      class="project-box row m-0 p-0"
    >
      <div class="col-7 p-0 list-height">
        <div class="head row p-0 m-0">
          <div class="project-search input-group p-2">โครงการทั้งหมด</div>
        </div>
        <div class="projects col">
          <div class="all pointer" @click="selectProjectAll()">
            {{ $t("label.select_all") }}
          </div>

           <div v-if="Object.keys(projectGroups).length === 0" class="no-data-message">
            <p>ไม่มีข้อมูล</p>
          </div>

          <div
            v-for="(group, groupName) in projectGroups"
            :key="groupName"
            class="group-wrapper"
          >
            <div class="project-group" @click="selectProjectGroup(groupName)">
              {{ groupName }} - {{ group.length }} โครงการ
            </div>
            <div
              v-for="project in group"
              :key="project.projectId"
              class="project"
              @click="selectProject(project)"
            >
              {{ project.projectCode }} - {{ project.projectName }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectProjects" class="results-panel col-5 p-0 list-height">
        <div class="media projects-head">
          <div class="projects-counter media-body">
            เลือกแล้ว {{ selectProjects.length }} โครงการ
          </div>
          <div
            v-if="!disableDeleteAll"
            class="projects-remove pointer"
            @click="removeProjectAll()"
          >
            ลบทั้งหมด
          </div>
        </div>
        <div class="project-select col px-0">
          <div
            v-for="(selectedProject, index) in selectProjects"
            :key="selectedProject.projectId"
            :class="classList(selectedProject)"
            class="media tag"
          >
            <div class="media-body">
              {{ selectedProject.projectCode }} - {{ selectedProject.projectName }}
            </div>
            <div
              v-if="selectedProject.hasSelected === false"
              class="ms-3"
              @click="removeProject(index)"
            >
              <img src="/static/icons/close.svg" alt="remove" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap";
import { Select, Option } from "element-ui";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    "el-select": Select,
    "el-option": Option,
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableDeleteAll: {
      type: Boolean,
      default: false
    },
    lockPreviouslySelected: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const projectType = {
      L: "แนวราบ",
      H: "แนวสูง",
      NSL: "Non SC แนวราบ",
      NSH: "Non SC แนวสูง",
      B: "อาคาร"
    };

    return {
      filterProjectType: null,
      filterProvince: [],
      projects: [],
      projectGroups: {},
      projectType,
      projectTypes: [],
      province: [],
      searchProject: "",
      selectProjects: [],
      initSelected: [],
    };
  },
  computed: {
    inputProjects() {
      return this.value;
    },
    filteredProjects() {
      let filtered = this.projects.filter((pj) => {
        const matchesSearch =
          pj.projectName
            .toLowerCase()
            .indexOf(this.searchProject.toLowerCase()) > -1 ||
          pj.projectCode
            .toLowerCase()
            .indexOf(this.searchProject.toLowerCase()) > -1;

        return matchesSearch;
      });

      // Filter by project type
      if (this.filterProjectType && this.filterProjectType.key !== "") {
        filtered = filtered.filter((pj) => pj.projectType === this.filterProjectType.key);
      }

      // Filter by provinces
      if (this.filterProvince && this.filterProvince.length > 0) {
        filtered = filtered.filter((pj) => this.filterProvince.some(
            (province) => pj.provinceName === province.key
          ));
      }

      return filtered;
    },
  },
  watch: {
    value() {
      this.mapInputProjects();
    },
    searchProject() {
      this.buildProjectGroups();
    },
  },
  created() {
    this.getProjects();
    this.initSelected =
      this.lockPreviouslySelected && Array.isArray(this.value)
        ? [...this.value]
        : [];
  },
  methods: {
    classList(currentProject) {
      return { "disable-content": currentProject.hasSelected };
    },
    async getProjects() {
      const data = { searchText: this.searchProject };

      if (this.filterProjectType && this.filterProjectType.key) {
        data.type = this.filterProjectType.key;
      }

      const response = await baanRueJaiClient.admin.projects.list(data);
      this.projects = response.data;
      this.buildProjectGroups();
      this.mapInputProjects();
      this.buildProvinces();
      this.buildProjectTypes();
    },
    selectProjectAll() {
      this.filteredProjects.forEach((project) => {
        if (!this.checkProjectDuplicate(project)) {
          this.selectProjects = this.selectProjects.concat(project);
        }
      });
      this.$emit("input", this.selectProjects);
    },
    selectProjectGroup(name) {
      this.projectGroups[name].forEach((project) => {
        if (!this.checkProjectDuplicate(project)) {
          this.selectProjects = this.selectProjects.concat(project);
        }
      });
      this.$emit("input", this.selectProjects);
    },
    removeProjectAll() {
      this.selectProjects = [];
      this.$emit("input", this.selectProjects);
    },
    selectProject(project) {
      if (!this.checkProjectDuplicate(project)) {
        this.selectProjects = this.selectProjects.concat(project);
        this.$emit("input", this.selectProjects);
      }
    },
    removeProject(index) {
      this.selectProjects.splice(index, 1);
      this.$emit("input", this.selectProjects);
    },
    checkProjectDuplicate(project) {
      return this.selectProjects.some((pro) => {
        if (pro.projectId === project.projectId) {
          return true;
        }
        return false;
      });
    },
    filterProjectByProjectType(type) {
      this.filterProjectType = type;
      this.buildProjectGroups();
    },
    filterProjectByProvince(selectedProvinces) {
      this.filterProvince = selectedProvinces || [];
      this.buildProjectGroups();
    },
    mapInputProjects() {
      if (!this.value || !Array.isArray(this.value)) {
        this.selectProjects = [];
        return;
      }

      this.selectProjects = this.projects
        .filter((project) => this.value.some((p) => p.projectId === project.projectId))
        .map((project) => ({
          ...project,
          hasSelected: this.initSelected.find((p) => p.projectId === project.projectId) !== undefined
        }));
    },
    buildProjectGroups() {
      this.projectGroups = {};
      this.filteredProjects.forEach((project) => {
        if (!this.projectGroups[project.projectGroup]) {
          this.projectGroups[project.projectGroup] = [project];
        } else {
          this.projectGroups[project.projectGroup].push(project);
        }
      });
    },
    buildProvinces() {
      const provincesSet = new Set();
      this.projects.forEach((project) => {
        const provinceName = project.provinceName?.trim();
        if (provinceName) {
          provincesSet.add(provinceName);
        }
      });
      this.province = Array.from(provincesSet).map((province) => ({ key: province, name: province }));
    },
    buildProjectTypes() {
      const projectTypeSet = new Set();
      this.projects.forEach((project) => {
        projectTypeSet.add(project.projectType);
      });
      this.projectTypes = [
        { key: "", name: "ทุกประเภท" },
        ...Array.from(projectTypeSet).map((type) => ({ key: type, name: this.projectType[type] || type }))
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.project-selector {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: $black;
  padding-bottom: 16px;
}

.list-height {
  height: calc(100vh - 400px);
}

.project-box {
  border-radius: 15px;
  border: 1px solid #e0e0e0;
  max-height: calc(100vh - 400px);

  &.notActive {
    pointer-events: none;
  }
  &.error {
    border-color: $red;
  }
  .head {
    border-bottom: 1px solid #e0e0e0;
  }
  .results-panel {
    border-left: 1px solid #e0e0e0;

    &.no-left-border {
      border-left: none;
    }
  }
  .filter {
    padding: 6px 10px 0 0;
    text-align: left;
    border-left: 1px solid #e5e5e5;
  }
  input.form-control {
    border: none;
  }
  .dropdown {
    button {
      border: none;
    }
  }
}
.projects {
  background-color: #ffffff;
  height: calc(100% - 48px);
  padding: 10px;
  overflow-y: auto;

  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;

  &-counter {
    font-weight: bold;
    color: $orange;
  }
  &-head {
    padding: 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
  }
  &-remove {
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: -0.1px;
    text-align: right;
    color: #8c8786;
  }
  .all {
    font-weight: bold;
    color: $black;
    margin-bottom: 6px;
  }
}
.project {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
  padding-left: 16px;
  border-left: 1px solid #979797;

  &-group {
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: $black;
    margin: 8px 0;
  }
  &-select {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
  &:hover {
    color: $black;
  }
}
.dropdown {
  display: inline;
}
.input-group-text {
  background: none;
  border: none;
  background-color: $white;
}

.search-input-wrapper {
  position: relative;
  width: 100%;

  .search-input {
    padding: 20px 0 20px 40px;
    border: 1px solid #ddd;
    background-color: $white;
  }

  .search-icon {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
}
.tag {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: $black;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px;
}

.disable-content {
  pointer-events: none;
  opacity: 0.8;
  background-color: rgb(226, 226, 226);
  border-bottom: 1px solid #ffffff;
}

.label {
  display: block;
  line-height: 1.4;
  font-size: 1rem;
  font-weight: bold;
}

.el-select {
  width: 100%;

  .el-select__tags {
    max-height: 100px;
    overflow-y: auto;
  }

  .el-tag {
    background-color: #409eff;
    color: white;
    border: none;
    margin: 2px;
    border-radius: 15px;
  }

  .el-tag .el-tag__close {
    color: white;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
}

.no-data-message {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
